setUserChildAccount